var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('googlemaps-marker',{ref:"marker",attrs:{"icon":_vm.icon,"label":_vm.label,"position":_vm.position,"z-index":_vm.zIndex},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }